var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 69,
    viewBox: "0 0 71 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4600",
    x: 0,
    y: 0,
    width: 71,
    height: 69,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9850",
    "data-name": "Group 9850",
    transform: "translate(-658 -1751)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 658, 1751)",
    filter: "url(#Rectangle_4600)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4600-2",
    "data-name": "Rectangle 4600",
    transform: "translate(9 6)",
    fill: "#1aac7a",
    stroke: "#39ac85",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 51,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 52,
    height: 50,
    rx: 4.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "phone-call",
    transform: "translate(681.461 1771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4168",
    "data-name": "Group 4168",
    transform: "translate(0.539 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8702",
    "data-name": "Path 8702",
    d: "M22.4,16.507l-3.139-3.139a2.088,2.088,0,0,0-3.475.785A2.136,2.136,0,0,1,13.315,15.5c-2.242-.561-5.269-3.475-5.829-5.829A2.032,2.032,0,0,1,8.831,7.2a2.088,2.088,0,0,0,.785-3.475L6.477.589a2.239,2.239,0,0,0-3.027,0L1.32,2.718C-.81,4.96,1.545,10.9,6.813,16.171s11.21,7.735,13.452,5.493l2.13-2.13A2.239,2.239,0,0,0,22.4,16.507Z",
    transform: "translate(-0.539 0)",
    fill: "#fcfcfc"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallBtn);
export default __webpack_public_path__ + "static/media/call-btn.491dd2ab10be696343c2a609937dac9d.svg";
export { ForwardRef as ReactComponent };